import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { ArrowLeft } from 'lucide-react';
import { trackEvent } from '../../lib/analytics';

const Terms: React.FC = () => {
  useEffect(() => {
    trackEvent('legal_page', 'visit', 'terms');
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button 
            variant="ghost" 
            size="sm" 
            className="mb-6"
            leftIcon={<ArrowLeft size={16} />}
            onClick={() => trackEvent('navigation', 'back_from_terms', 'home')}
          >
            Back to Home
          </Button>
        </Link>
        
        <Card>
          <div className="p-6">
            <h1 className="text-2xl font-bold text-primary-800 font-display mb-6">Terms & Conditions</h1>
            
            <div className="space-y-6 text-neutral-700">
              <section>
                <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
                <p>
                  By accessing or using AI Pandit Ji services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not use our services.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">2. Service Description</h2>
                <p>
                  AI Pandit Ji provides AI-generated astrological readings and predictions based on user-provided birth information. These readings are for entertainment and informational purposes only.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">3. User Accounts</h2>
                <p>
                  To access certain features of our services, you must create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">4. Payment and Subscriptions</h2>
                <p>
                  We offer various subscription plans for premium services. By subscribing, you agree to pay all fees in accordance with the billing terms in effect at the time of your subscription. Payment obligations are non-cancelable, and fees paid are non-refundable.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">5. Disclaimer of Warranties</h2>
                <p>
                  AI Pandit Ji's services are provided "as is" without any warranty of any kind. The astrological readings and predictions are generated by AI and should not be considered as professional advice for making important life decisions.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">6. Limitation of Liability</h2>
                <p>
                  AI Pandit Ji shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">7. Governing Law</h2>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law principles.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">8. Changes to Terms</h2>
                <p>
                  AI Pandit Ji reserves the right to modify these Terms at any time. We will provide notice of significant changes by updating the date at the top of these Terms. Your continued use of the service after such changes constitutes your acceptance of the new Terms.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold mb-3">9. Contact Information</h2>
                <p>
                  If you have any questions about these Terms, please contact us at <a 
                    href="mailto:theaipanditji@gmail.com" 
                    className="text-primary-600 hover:underline"
                    onClick={() => trackEvent('user_engagement', 'email_click', 'terms_contact')}
                  >theaipanditji@gmail.com</a>.
                </p>
              </section>
            </div>
            
            <div className="mt-8 text-sm text-neutral-500 text-center">
              Last Updated: June 10, 2025
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Terms;